/**
 * @generated SignedSource<<3cccdead956f244d01fa938ecbb46a2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternalUserNameUpdateDialog_internalUser$data = {
  readonly id: string;
  readonly userName: string;
  readonly " $fragmentType": "InternalUserNameUpdateDialog_internalUser";
};
export type InternalUserNameUpdateDialog_internalUser$key = {
  readonly " $data"?: InternalUserNameUpdateDialog_internalUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternalUserNameUpdateDialog_internalUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternalUserNameUpdateDialog_internalUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userName",
      "storageKey": null
    }
  ],
  "type": "MATInternalUser",
  "abstractKey": null
};

(node as any).hash = "c85d7717dadce74ff6740b580c6d28c3";

export default node;
